/*
 * docx-preview 加载（使用模块内 vendor 文件，零外部依赖）
 *
 * docx-preview 0.3+ 用了 optional chaining 等新语法，Webpack 4 + 老 Babel 不转译 node_modules，
 * 直接 import 会报错。本模块从 vendor/ 把已编译的 .min.js 当字符串引入，
 * 运行时通过 Blob URL 注入 <script>。
 *
 * 全局对象 window.docx 由脚本注入。
 */

import {
  JSZIP_SOURCE,
  DOCX_PREVIEW_SOURCE,
  injectScriptFromSource
} from '../vendor'

interface DocxModule {
  renderAsync: (
    data: ArrayBuffer | Blob,
    bodyContainer: HTMLElement,
    styleContainer?: HTMLElement,
    options?: any
  ) => Promise<any>
}

let docxModule: DocxModule | null = null
let docxLoading: Promise<DocxModule> | null = null

export function loadDocxPreview(): Promise<DocxModule> {
  if (docxModule) return Promise.resolve(docxModule)
  if (docxLoading) return docxLoading

  docxLoading = (async () => {
    // jszip 是 docx-preview 的 peer dep，必须先注入
    await injectScriptFromSource('jszip', JSZIP_SOURCE)
    await injectScriptFromSource('docx-preview', DOCX_PREVIEW_SOURCE)
    const mod = (window as any).docx as DocxModule | undefined
    if (!mod || typeof mod.renderAsync !== 'function') {
      throw new Error('docx-preview 全局对象未注入（window.docx 不存在）')
    }
    docxModule = mod
    return mod
  })()
  return docxLoading
}
